import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#0a0a0a] py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>
        
        <div className="bg-white dark:bg-[#141414] rounded-xl p-6 md:p-8 shadow-sm border border-gray-200 dark:border-[#2a2a2a]">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-6">Privacy Policy</h1>
          
          <div className="space-y-6 text-gray-700 dark:text-gray-300 text-sm md:text-base">
            <p>
              UniConnect is a student-built platform designed to help students connect and communicate.
            </p>

            <div>
              <h2 className="font-semibold text-gray-900 dark:text-white mb-2">Information We Collect</h2>
              <p>We collect your email address and any content you post or message.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 dark:text-white mb-2">How We Use Information</h2>
              <p>We use this information only to operate and improve the platform.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 dark:text-white mb-2">Data Sharing</h2>
              <p>We do not sell or share your personal information.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 dark:text-white mb-2">User Content</h2>
              <p>Posts and messages may be visible to other users.</p>
            </div>

            <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4">
              <h2 className="font-semibold text-purple-900 dark:text-purple-300 mb-2">📧 Email Notifications</h2>
              <p className="text-purple-800 dark:text-purple-300">
                Email notifications are <strong>enabled by default</strong> for all users to keep you updated on new posts, replies, and messages in your communities. You can manage your notification preferences anytime in your <strong>Profile Settings</strong>.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 dark:text-white mb-2">Security</h2>
              <p>We take reasonable steps to protect your data but cannot guarantee complete security.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 dark:text-white mb-2">Changes</h2>
              <p>We may update this policy as the platform evolves.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
